import { StyleSheet } from 'react-native';
import { colors, defaultShadow, sizes } from '~/values';
import appStyles from '~/appStyles';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  logo: {
    width: 80,
    height: 45,
    alignSelf: 'flex-start',
    margin: 16,
    marginLeft: 0,
    marginTop: 4,
  },
  icon: {
    width: 20,
    height: 20,
    tintColor: colors.primaryColor,
  },
  infoContainer: {
    padding: 16,
    paddingTop: 0,
  },
  iconInfo: {
    width: 24,
    height: 24,
    marginRight: sizes.horizontalSpaceSmall,
    tintColor: colors.grayMid,
  },
  infoText: {
    fontSize: sizes.textNormal,
    color: colors.grayDark,
  },
  loginBoxContainer: {
    marginBottom: 8,
    backgroundColor: '#FFF',
    ...defaultShadow,
  },
  loginBoxInputs: {
    padding: 16,
  },
  switchContainer: {
    ...appStyles.rowDirection,
  },
  label: {
    color: colors.grayDark,
    fontWeight: '600',
    fontSize: sizes.textBig,
    margin: sizes.horizontalSpacing,
  },
  separator: {
    height: 1,
    backgroundColor: colors.grayContainerDark,
  },
  iconMenuDown: {
    width: 20,
    height: 20,
    tintColor: colors.grayDarkest,
  },
  storeTitle: {
    fontWeight: '600',
    fontSize: 16,
    marginBottom: 3,
  },
  storeItemTitle: {
    fontWeight: '600',
    fontSize: 14,
    marginBottom: 3,
  },
});

export default styles;
